import './../styles/main.scss'; 
import { browserSupportsAllFeatures } from './test';
import { isDefined, throttle } from './partials/helpers';
import { triggerRevealScroll } from './partials/scroll-reveal';
import { preloadTransition } from './partials/preload-transition';
import { initRealisation } from './partials/realisation';
import { initPartenaires } from './partials/partenaires';
import { initTemoignages } from './partials/temoignages';
import { initHeader } from './partials/header';
import { initProduit } from './partials/produit';
import { initActualites } from './partials/actualites';
import GLightbox from 'glightbox';
import ClbsCustomMulipleSelect from './partials/clbs_select';

if (module.hot) {
    module.hot.accept();
}

window.addEventListener('DOMContentLoaded', function() {
    
    if (!browserSupportsAllFeatures()) {
        // Require 'promise' for Parcel, then dynamic import polyfills.
        require('core-js/es/promise');
        import('./polyfill')
            .then(() =>
                console.log('Polyfills loaded... instantiate UI modules...')
            )
            .catch((e) => console.error(e));
    }

    if('IntersectionObserver' in window)
    {
        document.documentElement.classList.add('reveal-loaded')
        triggerRevealScroll();
    }

    setTimeout(function() {
        preloadTransition();
    }, 100);

    initHeader();
    initRealisation();
    window.lightbox = GLightbox();
    initPartenaires();
    initTemoignages();
    initProduit();
    initActualites();

    // Custom select multiple
    const customSelectMultiple = document.querySelectorAll('.clbs-custom-select');
    if(isDefined(customSelectMultiple))
    {
        customSelectMultiple.forEach(select => {
            new ClbsCustomMulipleSelect(select);
        });
    }
})